export const ceruleanSequential: string[] = [];
export const ceruleanSequentialMixed: string[] = [];
